import { Component, computed, effect, inject, signal } from "@angular/core"
import { httpResource } from "@angular/common/http"
import { Router } from "@angular/router"
import { ToastService } from "src/app/services"
import { Column, PagedPromotionalContent, TableLazyLoadEvent } from "../../models"
import { PromotionalContentService } from "../../services"
import { toPagedParams } from "../../helpers/TablePaging"
import { TableComponent } from "../../components/table/table.component"

@Component({
    selector: "valben-promotional-content-table",
    templateUrl: "./promotional-content-table.page.html",
    styles: [`
        :host {
            width: 100%;
            flex: 1 1 auto;
            min-height: 0;
            display: flex;
            flex-direction: column;
        }
    `],
    standalone: true,
    imports: [TableComponent],
})
export class PromotionalContentTablePage {
    private _promContentService = inject(PromotionalContentService)
    private _messageService = inject(ToastService)
    private _router = inject(Router)

    cols: Column[] = [
        { field: "createdByUser", header: "Kreiranje", bodyType: "text", filterType: "text", filterMode: "contains", pairWith: "modifiedByUser" },
        { field: "modifiedByUser", header: "Zadnja izmjena", bodyType: "text", filterType: "text", filterMode: "contains", prefix: "↳" },
        { field: "createdDate", header: "Datum kreiranja", bodyType: "datetime", filterType: "date", filterMode: "dateIs", sortable: true, pairWith: "modifiedDate" },
        { field: "modifiedDate", header: "Datum izmjene", bodyType: "datetime", filterType: "date", filterMode: "dateIs", sortable: true },
        { field: "isActive", header: "Aktivan", bodyType: "boolean", filterType: "boolean", sortable: true, trueText: "Aktivna", falseText: "Neaktivna", pairWith: "isDraft" },
        { field: "isDraft", header: "Skica", bodyType: "boolean", filterType: "boolean", sortable: true, trueText: "Skica", falseText: "Bez skice" },
        { field: "version", header: "Verzija", bodyType: "number", filterType: "numeric", sortable: true, prefix: "v" },
        { field: "contentUrl", header: "Media", bodyType: "file", icon: "perm_media" },
    ]

    private _pageRequest = signal<TableLazyLoadEvent | undefined>(undefined)

    promContent = httpResource<PagedPromotionalContent>(() => {
        const event = this._pageRequest()
        return event ? this._promContentService.PagedRequest(toPagedParams(event, this.cols)) : undefined
    })

    tableValues = computed(() =>
        (this.promContent.value()?.items ?? []).map(pc => ({
            ...pc,
            createdDate: new Date(pc.createdDate),
            modifiedDate: new Date(pc.modifiedDate),
        }))
    )

    totalRecords = computed(() => this.promContent.value()?.totalCount ?? 0)
    loading = computed(() => this.promContent.isLoading())

    refresh = () => this.promContent.reload()

    constructor() {
        effect(() => {
            if (!this.promContent.error()) return
            this._messageService.add({
                severity: "error",
                summary: "Greška",
                detail: "Došlo je do pogreške prilikom dohvata promotivnog sadržaja.",
                life: 10000,
            })
        })
    }

    loadPage(event: TableLazyLoadEvent): void {
        setTimeout(() => this._pageRequest.set(event))
    }

    add(): void {
        this._router.navigate(["/promotional-content/add"])
    }

    edit(masterId: string): void {
        this._router.navigate(["/promotional-content/edit", masterId])
    }
}
